<template>
    <div>
        <form @submit.prevent="submitForm">
            <div class="preview_wrap">
                <div id="preview">
                    <img v-if="url" :src="url" width="90" height="90"/>
                    <p v-else>아이콘<br> 미리보기</p>
                </div>
            </div>
            <div class="form-control">
                <label for="icon" class="inp">
                    <input type="file" id="icon" @change="onFileChange" accept='image/jpeg,image/gif,image/png'/>
                    <span class="label">아이콘</span>
                    <span class="focus-bg"></span>
                </label>
            </div>

            <div class="form-control">
                <label for="inp" class="inp" :class="{ invalid: !title.isValid }">
                    <input
                    type="text"
                    id="title"
                    v-model.trim="title.val"
                    @blur="clearValidity('title')"
                    placeholder="&nbsp;"
                    />
                    <span class="label">제목</span>
                    <span class="focus-bg"></span>
                </label>
            </div>

            <div class="form-control">
                <label for="inp" class="inp" :class="{ invalid: !subtitle.isValid }">
                    <input
                    type="text"
                    id="subtitle"
                    v-model.trim="subtitle.val"
                    @blur="clearValidity('subtitle')"
                    placeholder="&nbsp;"
                    />
                    <span class="label">부 제목</span>
                    <span class="focus-bg"></span>
                </label>
            </div>

            <!-- <div class="form-control">
                <label for="selectPostDocument" class="inp">
                    <select v-model="max.val">
                        <option value="100" >100</option>
                        <option value="200" >200</option>
                    </select>
                    <span class="label">최대인원</span>
                    <span class="focus-bg"></span>
                </label>
            </div> -->

            <!-- <div class="form-control">
                <label for="selectPostDocument" class="inp">
                    <select v-model="limitation.val">
                        <option value="0" >없음</option>
                        <option value="1" >1</option>
                        <option value="2" >2</option>
                    </select>
                    <span class="label">레벨제한</span>
                    <span class="focus-bg"></span>
                </label>
            </div> -->

            <!-- <div class="form-control">
                <label for="selectPostDocument" class="inp">
                    <select v-model="category.val">
                        <option value="게임" >게임</option>
                        <option value="포커" >포커</option>
                        <option value="바둑이" >바둑이</option>
                        <option value="맞고" >맞고</option>
                    </select>
                    <span class="label">카테고리</span>
                    <span class="focus-bg"></span>
                </label>
            </div> -->

            <div class="actions">
                <div class="btn_wrap"><base-button mode="darkblue">생성</base-button></div>
                <div class="btn_wrap"><base-button @click="gochatlobby"  mode="outline_gray">취소</base-button></div>
            </div>

        </form>
    </div>
</template>
<script>
export default {
    props:{
        isMobile:{
            type: Boolean,
            default:false,
        }
    },
    data(){
        return{
            title: {
                val: "",
                isValid: true,
            },
            subtitle: {
                val: "",
                isValid: true,
            },
            max: {
                val: 100,
                isValid: true,
            },
            limitation: {
                val: 0,
                isValid: true,
            },
            category: {
                val: "게임",
                isValid: true,
            },
            icon: {
                val: "",
                isValid: true,
            },
            url:null,
            imageUrl:"",
            formIsValid: true,
        }
    },
    methods:{
        onFileChange:function(e) {
            const file = e.target.files[0];
            console.log(file.type);
            //이미지만 허용
            if(file.type.indexOf('image')==-1)
            {
                alert('이미지만 업로드 가능 합니다.');
                this.icon.val="";
                return;
            }
            this.icon.val =file;   
            let reader = new FileReader();
            reader.readAsDataURL( file );

            reader.onload = () => {
                    this.imageUrl = reader.result;
            };
            this.url = URL.createObjectURL(file);
            console.log(this.url);
        },
        clearValidity(input) {
            if(this[input].val !=='')
            {
                this[input].isValid = true;
            }
        },
        validateForm() {
            this.formIsValid = true;
            if (this.title.val === "") {
                this.title.isValid = false;
                this.formIsValid = false;
            }
            if (this.subtitle.val === "") {
                this.subtitle.isValid = false;
                this.formIsValid = false;
            }
        },
        submitForm() {
            this.validateForm();

            if (!this.formIsValid) {
                return;
            }

            let formData = new FormData();
            formData.append("user_id", this.$store.getters.currentUser.id);
            formData.append("title", this.title.val);
            formData.append('subtitle',this.subtitle.val);
            formData.append('icon',this.icon.val);
            formData.append('max',this.max.val);
            formData.append('limitation',this.limitation.val);
            formData.append('category',this.category.val);
            this.$emit("save-data", formData);
            //this.clear();
        },
        gochatlobby:function(){
            if(this.isMobile)
            {
                this.$emit("cancel");
            }else{
                this.$router.push("/chat/lobby");
            }
            
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/form";
.preview_wrap{
    margin-bottom:20px;
    text-align:center;
    display:flex;
    justify-content: center;
    #preview{
        border:5px solid #ccc;
        width:100px;
        height:100px;
        border-radius:10px;
        p{
            padding-top:20px;
            color:#ccc;
        }
    }
}
.actions{
  display: flex;
  justify-content: center;
  .btn_wrap{width:30%;padding:10px;}
}
</style>
